export class ApplicationConfirmModel {
  app_year: string;
  profileId: string;
  username: string;
}
